var newsletter_optin = ( function( $ ) {

	var _init = function() {
		console.log('init');
		_setup_optin_button();
	};

	var _setup_optin_button = function() {
		$('#subscribe-optin').on( 'click', function( e ) {
			console.log('click');
			$(this).text('Saving...').addClass( 'loading' );

			e.preventDefault();

			_optin_user();
		} );
	};

	var _optin_user = function() {
		var data = {
			action : 'crate_optin_user',
			nonce : ScriptData.crate_optin_user_popup_nonce
		};

		$.post( ScriptData.ajaxurl, data, _optin_user_response );
	};

	var _optin_user_response = function( response ) {
		$('#subscribe-optin').removeClass( 'loading' );

		if ( response.refresh ) {
			window.location.reload();
		}
	};

	$( document ).ready( _init );

} )( jQuery );

module.exports = newsletter_optin;